import { ReactNode } from 'react';
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldLabel,
} from '@/Domain/components/Shared/Field/Field';
import { cn } from '@/Domain/utils/cn';

interface IdentityFieldRowProps {
  id?: string;
  label: string;
  description?: ReactNode;
  children: ReactNode;
  align?: 'center' | 'start';
  /** Rendered inline after the label, e.g. an upgrade badge. */
  labelAddon?: ReactNode;
}

/**
 * A single Identity settings row: label + description on the left, control on
 * the right. Built on the shared Field primitives, mirroring the Settings /
 * IntegrationControlField pattern.
 */
export const IdentityFieldRow = ({
  id,
  label,
  description,
  children,
  align = 'center',
  labelAddon,
}: IdentityFieldRowProps) => (
  <Field
    orientation="horizontal"
    className={cn('gap-6 py-5', align === 'start' ? 'items-start' : 'items-center')}
  >
    <FieldContent>
      <div className="flex flex-wrap items-center gap-2">
        <FieldLabel htmlFor={id} className="font-medium">
          {label}
        </FieldLabel>
        {labelAddon}
      </div>
      {description ? <FieldDescription className="pb-0">{description}</FieldDescription> : null}
    </FieldContent>
    <div className="min-w-0 flex-1">{children}</div>
  </Field>
);
